import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import one from "@/components/1/index.vue";

const router = createRouter({
  routes: [
    {
      path: "/",
      redirect: "/1",
    },
    { redirect: "/1" },
    {
      path: "/1",
      name: "执勤车辆",
      component: one,
    },
   

  ],
  history: createWebHashHistory(),
});
export default router;
